import React, { useState } from "react";
import * as Components from "components";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "utils/sortable/src";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  DndContext,
  DragOverlay,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "utils/core/src";
import { useDispatch, useSelector } from "react-redux";
import { moveRow, editHabit } from "actions/habits";
import { toggleGroup } from "actions/groups";

export default function Menu({ rows }) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 2,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const [disableSort, setDisableSort] = useState(false);
  const [hoveringGroup, setHoveringGroup] = useState(false);

  const dispatch = useDispatch();
  const controlPanel = useSelector((state) => state.controlPanel);
  const habitsEntities = useSelector((state) => state.habitsEntities);
  const groupsEntities = useSelector((state) => state.groupsEntities);
  const isFilteringGroup = useSelector((state) => state.boardFilter?.groupId);
  const [activeId, setActiveId] = useState(null);

  function setHabitGroup({ habitId, groupId }) {
    const habit = habitsEntities[habitId];
    if (habit.group_id === groupId) return;
    dispatch(
      editHabit({
        ...habit,
        group_id: groupId,
      })
    );
    dispatch({
      type: "CHANGE_HABIT_GROUP",
      habitId,
      from: habit.group_id,
      to: groupId,
    });
  }

  function onDragOver(event) {
    // console.log(disableSort);
    //  if (disableSort) return;
    const { active, over } = event;

    if (!active || !over) return;

    const activeRow = active.data.current;
    const overRow = over.data.current;

    if (active?.id !== over?.id) {
      dispatch(
        moveRow({
          rowFrom: activeRow,
          rowTo: overRow,
        })
      );
    }
  }

  function onDragEnd(event) {
    //event.preventDefault();
    if (hoveringGroup) {
      const { active, over } = event;

      const activeRow = active.data.current;

      dispatch(
        moveRow({
          rowFrom: activeRow,
          rowTo: hoveringGroup,
          hoverGroupId: hoveringGroup.id,
        })
      );
    }
    // return;
    setActiveId(null);
  }

  function onDragStart(event) {
    const row = event.active.data.current;
    if (row.expanded) {
      dispatch(toggleGroup(row.id));
    }
    setActiveId(event.active.id);
  }

  return (
    <DndContext
      sensors={sensors}
      modifiers={[restrictToVerticalAxis]}
      collisionDetection={closestCenter}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
      hoveringGroup={hoveringGroup}
      setHoveringGroup={setHoveringGroup}
      setHabitGroup={setHabitGroup}
      rows={rows}
    >
      <SortableContext
        strategy={verticalListSortingStrategy}
        items={rows}
        disableSort={disableSort}
        setDisableSort={setDisableSort}
      >
        <div
          className={`menu ${
            controlPanel.isVisible ? "menu-with-control-panel" : ""
          }`}
        >
          {isFilteringGroup && rows.length === 0 ? (
            <div
              style={{
                height: "40px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>
          ) : (
            <ul>
              {rows.map((row) =>
                row.isHabit ? (
                  <Components.MenuHabitItem
                    key={"menu-habit-" + row.id}
                    id={row.id}
                  />
                ) : (
                  <Components.MenuGroupItem
                    key={"menu-group-" + row.id}
                    id={row.id}
                  />
                )
              )}
            </ul>
          )}
        </div>

        {/* <DragOverlay>
          {activeId ? (
            <div className="dragPreview">{habitsEntities[activeId].name}</div>
          ) : null}
          </DragOverlay> */}
      </SortableContext>
    </DndContext>
  );
}
